import PropTypes from 'prop-types';
import React, { memo, useEffect, useState, useId } from 'react';
import { List } from 'immutable';
import classNames from 'classnames';

import { IconButton } from '../../../../helpers/IconButton';
import style from './style.module.css';

const TableFilesComponent = ({ files, onDeleteFile, onUploadFile }) => {
  const prefix = `table-file-${useId()}`.replaceAll(':', '_');
  const [fileEvent, setFileEvent] = useState(null);

  useEffect(() => {
    if (fileEvent) {
      onUploadFile(fileEvent);
      setFileEvent(null);
    }
  }, [fileEvent]);

  const handleSelectFile = event => {
    if (event.target.value !== '') {
      setFileEvent(event);
    }
  };

  const isFileExist = (files, type) =>
    files?.size > 0 && files.filter(file => file.get('type') === type).getIn([0, 'id']) !== '';

  const isDisabledDelete = type => !isFileExist(files, type);

  const handleDeleteClick = (event, onDeleteFile, file) => {
    event.preventDefault();
    event.stopPropagation();
    onDeleteFile(event, file);
  };

  return (
    <div className={style.host}>
      <div className={style.tableWrap}>
        <table className="table table-bordered table-align-middle">
          <thead>
            <tr>
              <th>Name</th>
              <th className="w15p">Action</th>
            </tr>
          </thead>
          <tbody>
            {files?.map(file => (
              <tr key={file.get('id')}>
                <td className="text-left">{file.get('originalName')}</td>
                <td className="pt5 pb5 text-center">
                  <div className={style.actions}>
                    <IconButton
                      disabled={isDisabledDelete(file.get('type'))}
                      icon="trash"
                      onClick={event => {
                        handleDeleteClick(event, onDeleteFile, file);
                      }}
                      size="sm"
                      title="Delete"
                      variant="danger"
                    />
                    <IconButton href={file.get('url')} icon="external-link" size="sm" title="Open" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={style.controls}>
        <div>
          <label
            className={classNames(style.upload, 'btn btn-sm btn-primary')}
            htmlFor={`${prefix}-company-file-upload-file`}
          >
            <input
              className={classNames(style.fileInput, 'input-file-button')}
              id={`${prefix}-company-file-upload-file`}
              name="file"
              onChange={handleSelectFile}
              type="file"
            />
            Upload
          </label>
          <input name={`${prefix}-name`} type="hidden" value={fileEvent?.target.files.item(0)?.name} />
        </div>
      </div>
    </div>
  );
};

TableFilesComponent.propTypes = {
  files: PropTypes.instanceOf(List).isRequired,
  onDeleteFile: PropTypes.func.isRequired,
  onUploadFile: PropTypes.func.isRequired,
};

/** Table files component. */
export const TableFiles = memo(TableFilesComponent);
